import React, { useEffect, useState } from "react";
import InputsOne from "./inputs/InputsOne";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import ProfileImage from "./profileImage";
import InterestInput from "../InterestInput/InterestInput";

const ProfileEdit = ({ userProfile, fetchProfileData }) => {
  const accessToken = localStorage.getItem("@user");

  const [formData, setFormData] = useState({
    first_name: "",
    email: "",
    gender: "",
    age: "",
    instagram_link: "",
    facebook_link: "",
    linkedin_link: "",
    x_link: "",
    about_me: "",
    interests: [],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name.toLowerCase()]: value });
  };

  const handleInterestsChange = (updatedInterests) => {
    setFormData((prevData) => ({
      ...prevData,
      interests: updatedInterests,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.put(
        "https://htprdapi.hightable.ai/profile-members/update",
        formData,
        {
          params: { access_token: accessToken },
          headers: { "Content-Type": "application/json" },
        }
      );
      window.location.reload();
      toast.success("Profile Edited successfully!", { position: "top-center" });
      console.log("Profile updated successfully:", response.data);
      localStorage.setItem("@userAccount", response.data.data.id);
      localStorage.setItem("@userName", response.data.data.first_name);
      localStorage.setItem("@userPhone", response.data.data.phone);
      localStorage.setItem("@userPhoto", response.data.data.photo);
      localStorage.setItem("email", response.data.data.email);
      localStorage.setItem("age", response.data.data.age);
      localStorage.setItem("gender", response.data.data.gender);
    } catch (error) {
      window.location.reload();
      toast.success("Profile Edited successfully!", { position: "top-center" });
    }
  };

  useEffect(() => {
    setFormData(userProfile);
  }, [userProfile]);

  return (
    <div>
      <ToastContainer />
      <div
        id="w-node-_8af30e3c-d563-cc2d-005d-c6de7b4297be-1538e4e7"
        className="edit-profile"
      >
        <div className="edit-profile-form w-form">
          <form
            id="wf-form-signup"
            name="wf-form-signup"
            data-name="signup"
            method="get"
            data-ms-form="signup"
            className="signup-container-profile-edit"
            data-wf-page-id="674c4bd4a2796e5a1538e4e7"
            data-wf-element-id="c0af0e32-571a-6f65-650c-11a88c7aa943"
          >
            <h4 className="edit-profile-hesding">Edit Profile</h4>
            <ProfileImage
              userProfile={userProfile}
              fetchProfileData={fetchProfileData}
            />
            <InputsOne
              handleChange={handleChange}
              formData={formData}
              handleSubmit={handleSubmit}
            />
            <InterestInput
              selectedInterests={formData.interests}
              onInterestsChange={handleInterestsChange}
            />
            <div className="edit-profile-subheadings">
              <label htmlFor="email-2" className="ms-input-label">
                Connect Social Media
              </label>
            </div>
            <div className="edit-profile-connect-social-media-wrapper">
              <div className="connect-social-icon-wrapper">
                <div className="flag-code-wrapper">
                  <div className="flagcode w-embed">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="100%"
                      height="100%"
                      viewBox="0 0 48 48"
                    >
                      <radialGradient
                        id="yOrnnhliCrdS2gy~4tD8ma_Xy10Jcu1L2Su_gr1"
                        cx="19.38"
                        cy="42.035"
                        r="44.899"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset={0} stopColor="#fd5" />
                        <stop offset=".328" stopColor="#ff543f" />
                        <stop offset=".348" stopColor="#fc5245" />
                        <stop offset=".504" stopColor="#e64771" />
                        <stop offset=".643" stopColor="#d53e91" />
                        <stop offset=".761" stopColor="#cc39a4" />
                        <stop offset=".841" stopColor="#c837ab" />
                      </radialGradient>
                      <path
                        fill="url(#yOrnnhliCrdS2gy~4tD8ma_Xy10Jcu1L2Su_gr1)"
                        d="M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20	c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20	C42.014,38.383,38.417,41.986,34.017,41.99z"
                      />
                      <radialGradient
                        id="yOrnnhliCrdS2gy~4tD8mb_Xy10Jcu1L2Su_gr2"
                        cx="11.786"
                        cy="5.54"
                        r="29.813"
                        gradientTransform="matrix(1 0 0 .6663 0 1.849)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset={0} stopColor="#4168c9" />
                        <stop
                          offset=".999"
                          stopColor="#4168c9"
                          stopOpacity={0}
                        />
                      </radialGradient>
                      <path
                        fill="url(#yOrnnhliCrdS2gy~4tD8mb_Xy10Jcu1L2Su_gr2)"
                        d="M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20	c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20	C42.014,38.383,38.417,41.986,34.017,41.99z"
                      />
                      <path
                        fill="#fff"
                        d="M24,31c-3.859,0-7-3.14-7-7s3.141-7,7-7s7,3.14,7,7S27.859,31,24,31z M24,19c-2.757,0-5,2.243-5,5	s2.243,5,5,5s5-2.243,5-5S26.757,19,24,19z"
                      />
                      <circle cx="31.5" cy="16.5" r="1.5" fill="#fff" />
                      <path
                        fill="#fff"
                        d="M30,37H18c-3.859,0-7-3.14-7-7V18c0-3.86,3.141-7,7-7h12c3.859,0,7,3.14,7,7v12	C37,33.86,33.859,37,30,37z M18,13c-2.757,0-5,2.243-5,5v12c0,2.757,2.243,5,5,5h12c2.757,0,5-2.243,5-5V18c0-2.757-2.243-5-5-5H18z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="input-wrapper">
                <input
                  className="form-field w-input"
                  maxLength={256}
                  name="instagram_link"
                  data-name="Instagram Username"
                  placeholder="Instagram Username"
                  type="text"
                  id="Instagram-Username"
                  value={formData?.instagram_link}
                  onChange={handleChange}
                  data-ms-member="phone"
                  required=""
                />
              </div>
            </div>
            <div className="edit-profile-connect-social-media-wrapper">
              <div className="connect-social-icon-wrapper">
                <div className="flag-code-wrapper">
                  <div className="flagcode w-embed">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="100%"
                      height="100%"
                      viewBox="0 0 48 48"
                    >
                      <path
                        fill="#0288D1"
                        d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
                      />
                      <path
                        fill="#FFF"
                        d="M12 19H17V36H12zM14.485 17h-.028C12.965 17 12 15.888 12 14.499 12 13.08 12.995 12 14.514 12c1.521 0 2.458 1.08 2.486 2.499C17 15.887 16.035 17 14.485 17zM36 36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698-1.501 0-2.313 1.012-2.707 1.99C24.957 25.543 25 26.511 25 27v9h-5V19h5v2.616C25.721 20.5 26.85 19 29.738 19c3.578 0 6.261 2.25 6.261 7.274L36 36 36 36z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="input-wrapper">
                <input
                  className="form-field w-input"
                  maxLength={256}
                  name="linkedin_link"
                  data-name="LinkedIn Username"
                  placeholder="LinkedIn Username"
                  type="text"
                  id="linkedin_id"
                  data-ms-member="phone"
                  required=""
                  value={formData?.linkedin_link}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="edit-profile-connect-social-media-wrapper">
              <div className="connect-social-icon-wrapper">
                <div className="flag-code-wrapper">
                  <div className="flagcode w-embed">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="100%"
                      height="100%"
                      viewBox="0 0 30 30"
                    >
                      <path d="M 6 4 C 4.895 4 4 4.895 4 6 L 4 24 C 4 25.105 4.895 26 6 26 L 24 26 C 25.105 26 26 25.105 26 24 L 26 6 C 26 4.895 25.105 4 24 4 L 6 4 z M 8.6484375 9 L 13.259766 9 L 15.951172 12.847656 L 19.28125 9 L 20.732422 9 L 16.603516 13.78125 L 21.654297 21 L 17.042969 21 L 14.056641 16.730469 L 10.369141 21 L 8.8945312 21 L 13.400391 15.794922 L 8.6484375 9 z M 10.878906 10.183594 L 17.632812 19.810547 L 19.421875 19.810547 L 12.666016 10.183594 L 10.878906 10.183594 z" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="input-wrapper">
                <input
                  className="form-field w-input"
                  maxLength={256}
                  name="x_link"
                  data-name="X Username"
                  placeholder="X Username"
                  type="text"
                  id="X-Username"
                  data-ms-member="phone"
                  required=""
                  value={formData?.x_link}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="edit-profile-connect-social-media-wrapper">
              <div className="connect-social-icon-wrapper">
                <div className="flag-code-wrapper">
                  <div className="flagcode w-embed">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="100%"
                      height="100%"
                      viewBox="0 0 48 48"
                    >
                      <path
                        fill="#3F51B5"
                        d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
                      />
                      <path
                        fill="#FFF"
                        d="M34.368,25H31v13h-5V25h-3v-4h3v-2.41c0.002-3.508,1.459-5.59,5.592-5.59H35v4h-2.287C31.104,17,31,17.6,31,18.723V21h4L34.368,25z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="input-wrapper">
                <a href="#" className="form-field connect-facebook w-button">
                  Connect Facebook
                </a>
              </div>
            </div>
            <div
              onClick={handleSubmit}
              data-wait="Please wait..."
              className="button-4 w-button"
              defaultValue="Update"
            >
              Update
            </div>
          </form>
          <div className="w-form-done">
            <div>Thank you! Your submission has been received!</div>
          </div>
          <div className="w-form-fail">
            <div>Oops! Something went wrong while submitting the form.</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileEdit;
